export function parseJWT(token) {
  if (!token) return null;

  try {
    const parts = token.split(".");

    // JWT must have 3 parts
    if (parts.length !== 3) {
      throw new Error("Invalid JWT format");
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    const jsonPayload = atob(base64);

    const decoded = JSON.parse(jsonPayload);

    // optional: check expiration
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      console.warn("Token expired");
      localStorage.removeItem("userInfo");
      return null;
    }

    return decoded;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
}
